<template>
<div id="reporte_cuentat_fracciones" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Selección de fechas de aplicación para generar el Reporte detallado de cuenta de afectación “T”
" class="elevation-1 px-5 py-3" >
            <span style="color:red;">*Estimado Usuario: la selección de fechas que a continuación se deben ingresar, NO se refieren a un rango de periodo. Los valores requeridos se refieren a la fecha de "Cargo" de las IMPORTACIONES que se busca valorar desde el inicio de su registro como empresa Certificada IVA & IEPS, así como los "Abonos" reportados a la fecha de transmisión del informe de descargos al SCCCyG.</span>
          <br>

              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col cols="12" sm="6" md="6" lg="6" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_cargo" label="Fecha De Cargo" color="secondary" prepend-icon="event" @blur="model.fecha_cargo = parseDate(model.fecha_cargo)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_cargo" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_abono" label="Fecha de Abono" color="secondary" prepend-icon="event" @blur="model.fecha_abono= parseDate(model.fecha_abono)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaFecha]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_abono" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>  
                      <v-row >
                            <v-col cols="12" md="3" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                <v-autocomplete v-model="model.activo" :items="Super?list_activos:list_activos_user" :hide-no-data="true" 
                                    item-text="text" item-value="id" @change="getFracciones()"
                                    :return-object="false"  label="Identificador" >
                                </v-autocomplete>
                                <v-text-field v-if="model.activo=='O'" v-model="model.otro" label="Ingrese el Identificador" 
                                @change="getFracciones()" :rules="model.activo=='O'?[rules.required]:[]">
                                </v-text-field>
                            </v-col>                      
                            <v-col cols="12" md="3" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                <v-autocomplete v-model="model.fraccion" :items="fracciones" :hide-no-data="true"
                                    :loading="loadingfracciones" :rules="[rules.required]"
                                    clearable :return-object="false"  label="Seleccione una Fracción">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2" style="text-align:right !important;">
                              <v-btn color="info" @click="generar_reporte_sqs" >
                                  <v-icon>search</v-icon>Generar
                                </v-btn>                                
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2" style="text-align:left !important;">
                                <exportar-excel v-if="datos.reportes.length > 0" :data="datafiltered" :exportFields="campos_exportar" 
                                  name="cuentaT_por_fraccion.xlsx">
                                  <v-btn light color="green" title="Exportar a Excel" v-tippy>
                                      <v-icon dark>mdi-table</v-icon> Excel
                                  </v-btn>
                              </exportar-excel>
                            </v-col>
                      </v-row>                    
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  
                  
                    <v-row dense style="text-align:center !important;" v-if="datos.reportes.length > 0">
                      <v-col sm="12" lg="12" md="12">
                        <v-row dense>
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong>Cargos</strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong>Abonos</strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong>Saldo</strong>
                          </v-col>
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>
                        </v-row>
                        <v-row dense>   
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>                    
                          <v-col lg="2" md="2" sm="2">
                            <strong>${{formatNumberDec(totalCargos,2)}}</strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong><span style="color:green">${{formatNumberDec(totalAbonos,2)}}</span></strong>
                          </v-col>
                          <v-col lg="2" md="2" sm="2">
                            <strong><span style="color:maroon">${{formatNumberDec(totalSaldo,2)}}</span></strong>
                          </v-col>
                          <v-col lg="3" md="3" sm="3">
                              &nbsp;
                          </v-col>
                        </v-row>
                      </v-col>                    
                    </v-row>
                  
                  
                </v-card-actions>
                <v-card-text v-if="cliente!='' && domicilio!='' && datos.reportes.length > 0">                  
                  <div style="text-align:right !important;">Fecha de Consulta: {{ fecha_actual }}</div>
                  {{cliente.nombre}} - {{cliente.identificador}} 
                  <br>
                  C. {{domicilio.domicilio.toUpperCase()}}, Col. {{domicilio.colonia.toUpperCase()}}
                  C.P. {{domicilio.codigo_postal}}, {{domicilio.estado_nombre.toString().toUpperCase()}},
                  {{domicilio.pais.clave_m3.toString().toUpperCase()}}<br><br>

                  <div style="text-align:center !important;">
                  <strong>Servicio de consulta de movimientos en el SCCCyG / Fracciones Detallado / SoluciónA31</strong>
                  <br>
	                Fecha de aplicación de Cargos: {{model.fecha_cargo}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                  Fecha de aplicación de Abonos: {{model.fecha_abono}} 	
                  </div>
                  
                </v-card-text>
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="tipo_cambio" slot-scope="props">
                      <div style="text-align:right">{{ props.row.tipo_cambio}}</div>
                    </template>
                    <template slot="cantidad_pedimento" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.cantidad_pedimento,2)}}</div>
                    </template>
                    <template slot="valor_comercial" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.valor_comercial,2)}}</div>
                    </template>
                    <template slot="importe_iva" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.importe_iva,2)}}</div>
                    </template>
                    <template slot="importe_ieps" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.importe_ieps,2)}}</div>
                    </template>
                    <template slot="saldo_valor_comercial" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.saldo_valor_comercial,2)}}</div>
                    </template>
                    <template slot="saldo_importe_iva" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.saldo_importe_iva,2)}}</div>
                    </template>
                    <template slot="saldo_importe_ieps" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.saldo_importe_ieps,2)}}</div>
                    </template>
                    <template slot="cantidad" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.cantidad,2)}}</div>
                    </template>
                    <template slot="total_original" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.total_original,2)}}</div>
                    </template>
                    <template slot="valor_abonado" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.valor_abonado,2)}}</div>
                    </template>
                    <template slot="total_iva" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.total_iva,2)}}</div>
                    </template>
                    <template slot="total_ieps" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.total_ieps,2)}}</div>
                    </template>
                    <template slot="resto" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.resto,2)}}</div>
                    </template>
                    <template slot="sobredescargo" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(props.row.sobredescargo,2)}}</div>
                    </template>                   
                    
                  </v-client-table>
                </v-card-text>
              </div>

        </base-material-card>
      </v-col>
    </v-row>
    <LoaderFraces ref="estadoLoader" :mensajes="lista_mensajes" ></LoaderFraces>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
import LoaderFraces from "@/components/LoaderFraces";

export default {
  components: {
    "v-refresh-button": RefreshButton,
    LoaderFraces,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }    
    this.loading = false;    
    this.tipo = 1;
    this.fecha_actual = moment().format('YYYY-MM-DD');
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario"); 
    this.getFracciones();
    this.getFracciones_s();
    this.getCliente();  
    this.cargarPaises();
    this.cargarDomicilio(); 
  },
  computed: {    
        datafiltered() {

            let result = [];
            if (this.$refs.vuetable != null) {
               result = this.$refs.vuetable.allFilteredData;
                return result;
            } else {
               result = this.datos.reportes;
                return result;
            }
    },
    Super() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" 
            );
        },
  },
  data: () => ({    
    lista_mensajes: [
            "AGRADECEMOS SU PACIENCIA..",
            "ESTAMOS PROCESANDO LOS CARGOS..",
            "VERIFICANDO IDENTIFICADORES..", 
            "VALIDACIÓN DE FORMAS DE PAGO..", 
            "PROCESANDO ABONOS A LA FECHA..", 
            "VERIFICANDO FRACCIONES..",
            "VALIDANDO CUENTAS POR IDENTIFICADOR DE ACTIVO..",  
            "ANALIZANDO SOBREDESCARGO..", 
            "GESTIONANDO SALDOS POR FRACCIÓN..", 
            "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..", 
            "TOTALIZANDO CRÉDITO FISCAL.."
        ],
    fracciones_n:[],
    fracciones_s:[],
    loadingfracciones:false,
    fecha_actual:"",
    domicilio:"",
    cliente:"",
    paises:[],
    estados:[],
    totalCargos:0,
    totalAbonos:0,
    totalSaldo:0,
    permisoEliminar:false,
    list_activos:[
        {"id":"N","text":"Activo Fijo - No"}, //No Activo Fijos
        {"id":"S","text":"Activo Fijo - Si"}, //Activo Fijo  
        {"id":"O","text":"Otro"}, //No Activo Fijos      
    ],
    list_activos_user:[
        {"id":"N","text":"Activo Fijo - No"}, //No Activo Fijos
        {"id":"S","text":"Activo Fijo - Si"}, //Activo Fijo   
    ],
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Reportes",
        disabled: true,
        to: ""
      },
      {
        text: "Cuenta de afectación T",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: [],
      exportar: [],      
    },
    campos_exportar:{
        "Planta":"planta",
        "Numero de Pedimento":"no_pedimento",
        "Clave Documento":"clave_documento",
        "Tipo Documento":"tipo_pedimento",
        "Fecha Pago":"fecha_pago",
        "Fecha Rectificacion":"fecha_rectificacion",
        "T.C.":"tipo_cambio",
        "Fraccion Arancelaria":"fraccion_pedimento",
        "Identificador":"identificador",
        "Cantidad Total Expresada en Pedimento":"cantidad_pedimento",
        "UMT":"umt_pedimento",
        "Valor Comercial":"valor_comercial",
        "Credito IVA":"importe_iva",
        "Credito IEPS":"importe_ieps",
        "Saldo Valor Comercial":"saldo_valor_comercial",
        "Saldo Credito IVA":"saldo_importe_iva",
        "Saldo Credito IEPS":"saldo_importe_ieps",
        "Documento Informe":"folio",
        "Ejercicio":"ejercicio",
        "Periodo":"periodo",
        "Clave del Destino":"clave_destino_aduanero",
        "Fecha Recepcion":"fecha_recepcion",
        "Fecha Pago ":"fecha_pago",
        "Fecha Aplicacion":"fecha_aplicacion",
        "Estatus Validación":"estatus",
        "Fecha Validación":"fecha_validacion",
        "Identificador":"identificador",
        "Fraccion":"fraccion",
        "Cantidad":"cantidad",
        "UMT ":"umt",
        "Valor Comercial del Informe":"total_original",
        "Valor Comercial Abonado":"valor_abonado",
        "Abono Credito IVA":"total_iva",
        "Abono Credito IEPS":"total_ieps",
        "Balance de Valor Comercial":"resto",
        "Sobredescargo":"sobredescargo",
        "Archivo":"nombre_original"
    },
    
    columns_reportes: [
      "planta",
      "no_pedimento",
      "clave_documento",
      "tipo_pedimento",
      "fecha_pago",
      "fecha_rectificacion",
      "tipo_cambio",
      "fraccion_pedimento",
      "identificador",
      "cantidad_pedimento",
      "umt_pedimento",
      "valor_comercial",
      "importe_iva",
      "importe_ieps",
      "saldo_valor_comercial",
      "saldo_importe_iva",
      "saldo_importe_ieps",
      "folio",
      "ejercicio",
      "periodo",
      "clave_destino_aduanero",
      "fecha_recepcion",
      "fecha_pago",
      "fecha_aplicacion",
      "estatus",
      "fecha_validacion",
      "identificador",
      "fraccion",
      "cantidad",
      "umt",      
      "total_original",
      "valor_abonado",
      "total_iva",
      "total_ieps",
      "resto","sobredescargo", "nombre_original"],
    options_reportes: {
        filterable: true,
        filterByColumn: false,
        sortable: [],
        texts: {
            filter: '',
            filterPlaceholder: 'Buscar',
        },             

      headings: {
        "no_pedimento":"Numero de Pedimento",
        "clave_documento":"Clave Documento",
        "tipo_pedimento":"Tipo Documento",
        "fecha_pago":"Fecha Pago",
        "fecha_rectificacion":"Fecha Rectificacion",
        "identificador":"Identificador",
        "tipo_cambio":"T.C.",
        "fraccion_pedimento":"Fraccion Arancelaria",
        "cantidad_pedimento":"Cantidad Total Expresada en Pedimento",
        "umt_pedimento":"UMT",
        "valor_comercial":"Valor Comercial",
        "importe_iva":"Credito IVA",
        "importe_ieps":"Credito IEPS",
        "saldo_valor_comercial":"Saldo Valor Comercial",
        "saldo_importe_iva":"Saldo Credito IVA",
        "saldo_importe_ieps":"Saldo Credito IEPS",
        "folio":"Documento Informe",
        "clave_destino_aduanero":"Clave del Destino",
        "fecha_recepcion":"Fecha Recepcion",
        "fecha_aplicacion":"Fecha Aplicacion",
        "estatus":"Estatus Validación",
        "fecha_validacion":"Fecha Validación",
        "identificador":"Identificador",
        "fraccion":"Fraccion",
        "cantidad":"Cantidad",
        "umt":"UMT",
        "total_original":"Valor Comercial del Informe",
        "valor_abonado":"Valor Comercial Abonado",
        "total_iva":"Abono Credito IVA",
        "total_ieps":"Abono Credito IEPS",
        "resto":"Balance de Valor Comercial",
        "sobredescargo":"Sobredescargo",
        "nombre_original":"Nombre TXT"
      }            
    },
    loading: false,
    show_loading: true,
    list_reportes: [
            {
                "reporte": "Pref. Arancelarias Activo Fijo WS",
                "url": "/reportes_ws/partidas_activo_fijo/"
            },
            {
                "reporte": "Pref. Arancelarias Activo Fijo DS",
                "url": "/reportes_ds/partidas_activo_fijo_ds/"
            },            
    ],
    reportes_arr:[
        {id:1, val: "Completo"},
        {id:2, val: "Inventario Inicial"},
        {id:3, val: "Cargos"},
        {id:4, val: "Sobredescargos"},
    ],
    model: {
      rfc: "",
      usuario: "",
      fecha_cargo: "",
      fecha_abono: "",
      activo: "N",
      fraccion: "",
      opcion_reporte:1,
      reporte_url: "/soluciona31/reportes/rpt_cuentat_fracciones/",
      nombre_reporte: "Cuenta T Por Fracción",
      tipo: "SA31_CuentaT_Fracciones",     
      otro: "" 
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,

  }),
  methods: {
    cargarPaises: function () {
        axios
            .get(this.$hostname + "paises/")
            .then(res => {
                if (typeof res.data !== "undefined") this.paises = res.data;
                else {
                    this.$swal({
                        type: "warning",
                        title: "Aviso",
                        text: "No se han ingresado datos al catálogo de países",
                        footer: ""
                    });
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el catálogo de países.",
                    footer: ""
                });
                console.log(err);
            });
    },

    cargarPaisSeleccionado: function (id_pais) {
        axios
            .get(this.$hostname + "paises/" + id_pais + "/")
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.domicilio.pais = res.data;                    
                } else {
                    this.$swal({
                        type: "warning",
                        title: "Aviso",
                        text: "No se encontró el país guardado en el domicilio",
                        footer: ""
                    });
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el país del domiclio.",
                    footer: ""
                });
                console.log(err);
            });
    },    

    cargarDomicilio: function () {        
        var datos = {
            cliente: this.$local_storage.get("id_cliente")
        };
        axios
            .post(this.$hostname + "datos-clientes/get_domicilio_cliente/", datos)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.domicilio = res.data;
                    this.cargarPaisSeleccionado(res.data.pais);
                    this.update = true; //Significa, que ya tiene datos y hay que actualizarlos
                }
            })
            .catch(err => {
                if (typeof err.response.data.mensaje == "undefined") {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los datos de la organización.",
                        footer: ""
                    });
                    console.log(err);
                }
            });
    },
    getCliente: function () {                        
        let id = this.$local_storage.get("id_cliente");
        axios
            .get(this.$hostname + "clientes/" + id + "/")                
            .then(response => {
                this.cliente = response.data;                
            })
            .catch(error => {                    
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el cliente",
                    footer: ""
                });
            });
    },
    
    getTipo:function(opcion){
        var filtro = this.reportes_arr.find(e => e.id == opcion)
        if (filtro){
            return filtro.val;
        } else {
            return "";
        }
    },
    validaMes: function() {
        if (this.model.fecha_cargo != null && this.model.fecha_abono != null && this.model.fecha_cargo != "" && this.model.fecha_abono != "") {
            var inicio = moment(this.model.fecha_cargo, "YYYY-MM-DD");
            var fin = moment(this.model.fecha_abono, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, 'days')
            if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            if (Math.abs(diferencia) > 31)
                return "Periodo máximo de consulta 31 días. Favor de verificar.";
        }
        return true;
    },
    setNombreReporte: function () {
        var url = this.model.reporte_url
        var search = this.list_reportes.filter(function (e) {
            return e.url == url;
        });
        if (search.length > 0) {
            this.model.nombre_reporte = search[0].reporte;
        }
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_cargo != "" && this.model.fecha_abono != "") {
        var inicio = moment(this.model.fecha_cargo, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_abono, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    getFracciones:function(){       
        
        this.fracciones = [];
        this.model.fraccion = "";
       /*  if(this.model.activo == "N"){
          if (this.fracciones_n.length>0){
            this.fracciones = this.fracciones_n;
          }
        } else {
          if (this.fracciones_s.length>0){
            this.fracciones = this.fracciones_s;
          }
        }  */
        
        if (this.model.activo != 'O' || this.model.otro.length > 0 ) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.loadingfracciones = true;
          let identificador = this.model.activo;

            if(this.model.activo == 'O')
                identificador = this.model.otro;

          var data = {
              "identificador": identificador, //identificador de activo fijo N -> No, S -> Si
              "rfc": this.model.rfc
          };
          
          axios({
              method: "post",
              url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",            
              data: data
            })
            .then(response => {
                  if(response.data && response.data.length){
                      this.fracciones = response.data;
                     /*  if(this.model.activo == "N"){ 
                          this.fracciones_n = response.data;
                      } else {
                          this.fracciones_s = response.data;
                      }  */
                  } else {
                      this.fracciones = [];
                  }                    
            }).catch(error => {            
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
                footer: ""
              });
            }).then(() => {
              this.loadingfracciones = false;
              this.$root.$dialogLoader.hide();
            }); 
        }
        
    },
    getFracciones_s:function(){       
               
      var data = {
          "identificador": "S", //identificador de activo fijo N -> No, S -> Si
          "rfc": this.model.rfc
      };
      
      axios({
          method: "post",
          url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",            
          data: data
        })
        .then(response => {
              if(response.data && response.data.length){                  
                  this.fracciones_s = response.data;                  
              }                    
        }).catch(error => {            
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
            footer: ""
          });
        }); 
        
        
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    formatNumberDec: function(numero, decimales){
            if (numero!=0 && (numero == undefined || numero == null || numero == ""))
                return "";
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
    formatNumber: function (x) {
      if (x == undefined) return 0;
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },
    generar_reporte_sqs() {
        
      if (!this.$refs.form.validate())  {
        //Alguna operación o mensaje
      } else {       
            
        this.$refs.estadoLoader.show('ESPERE UN MOMENTO POR FAVOR..');
     

        var data = this.model;
        if(this.model.activo == 'O')
           data.activo = this.model.otro;
        this.totalCargos = 0;
        this.totalAbonos = 0;
        this.totalSaldo = 0;
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/rpt_cuentat_fracciones/",
            //url: "http://127.0.0.1:7000/soluciona31/reportes/rpt_cuentat_fracciones/",
            data: data
          })
          .then(response => {
            if (response.data != undefined) {
                this.datos.reportes = response.data["detalles"];
                
                this.totalCargos =  (response.data["totales"]["total_cargado"]).toFixed(2);
                this.totalAbonos = (response.data["totales"]["total_abonado"]).toFixed(2);
                this.totalSaldo = (response.data["totales"]["saldo"]).toFixed(2);
            } else {                
                this.datos.reportes = [];
                this.$swal({
                  type: "info",
                  title: "No se encontró información.",
                  text: "Con los criterios seleccionados. Favor de verificar.",
                  footer: ""
                });
            }
          })
          .catch(error => {
            this.$refs.estadoLoader.hide();
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {            
            this.$refs.estadoLoader.hide();
          });
      
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "SA31_CuentaT_Fracciones"
      };
      axios.post(this.$apiSA31+ "soluciona31/reportes/get_reportes/", data)      
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          return "Fecha Cargo: " + params.fecha_cargo + ", " + "Fecha Abono: " + params.fecha_abono;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)          
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();                         
            });
        }
      });
    },
  },
};
</script>
<style scoped>
    .class-center {
        text-align: center !important;
    }
    .class-right {
        text-align: right !important;
    }
</style>
